import { render } from "./GlobalLoadingOverlay.vue?vue&type=template&id=99d069fa&scoped=true"
import script from "./GlobalLoadingOverlay.vue?vue&type=script&lang=js"
export * from "./GlobalLoadingOverlay.vue?vue&type=script&lang=js"

import "./GlobalLoadingOverlay.vue?vue&type=style&index=0&id=99d069fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d069fa"]])

export default __exports__